"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchOpenidConfiguration = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _rest = require("../rest");

var _actions = require("./actions");

var _utils = require("../utils");

/* eslint-disable camelcase */
var fetchOpenidConfiguration = function fetchOpenidConfiguration() {
  return /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(dispatch) {
      var _scopes_supported$map, _grant_types_supporte, config, scopes_supported, grant_types_supported, scopesSupported, grantTypesSupported;

      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return (0, _rest.getOpenidConfigurationApi)();

            case 3:
              config = _context.sent;
              scopes_supported = config.scopes_supported, grant_types_supported = config.grant_types_supported; // eslint-disable-line

              scopesSupported = (scopes_supported === null || scopes_supported === void 0 ? void 0 : (_scopes_supported$map = scopes_supported.map) === null || _scopes_supported$map === void 0 ? void 0 : _scopes_supported$map.call(scopes_supported, function (scope) {
                return {
                  value: scope,
                  label: scope
                };
              })) || [];
              grantTypesSupported = (grant_types_supported === null || grant_types_supported === void 0 ? void 0 : (_grant_types_supporte = grant_types_supported.map) === null || _grant_types_supporte === void 0 ? void 0 : _grant_types_supporte.call(grant_types_supported, function (grantType) {
                var camelGrantType = (0, _utils.capitalizeFirstLetters)(grantType);
                return {
                  value: grantType,
                  label: camelGrantType
                };
              })) || [];
              dispatch((0, _actions.setOpenidConfiguration)({
                scopesSupported: scopesSupported,
                grantTypesSupported: grantTypesSupported
              }));
              _context.next = 13;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](0);
              // todo handle errors
              console.log(_context.t0);

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 10]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};

exports.fetchOpenidConfiguration = fetchOpenidConfiguration;
//# sourceMappingURL=utils.js.map